import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import OurServiceOffer from '../../Components/Automation/OurServiceOffer'
import { ChevronRight } from 'lucide-react'
import Perspectives from '../../Components/Accelerating/Perspectives'
import RelatedServices from '../../Components/Accelerating/RelatedServices'
import AccContact from '../../Components/Accelerating/AccContact'
import ScrollToTop from '../../Components/ScrollToTop'
import Banner from '../../Components/Banner'
import { Helmet } from 'react-helmet-async'
import ContactSection from '../../Components/home/ContactSection'

const relatedService = [
    {
        id: 1,
        title: "Cloud & DevOps Engineering",
        description: "Simplify your software delivery and build strong, scalable cloud systems that grow with your business, ensuring reliability, flexibility, and smooth performance every day.",
        image: "/assets/product/p1.png",
        link: "/cloud-dev-ops-engineering"
    },
    {
        id: 2,
        title: "Embedded Systems & Industrial",
        description: "Build reliable, real-time embedded and IoT solutions that simplify industrial automation, improve connectivity, and help businesses run smarter and more efficiently with Mobikode.",
        image: "/assets/product/p3.png",
        link: "/embedded-systems-industrial"
    },
    {
        id: 3,
        title: "Managed Services & Staff Augmentation",
        description: "Grow your technical capabilities faster with Mobikode’s dedicated experts and dependable managed services, designed to support your business every step.",
        image: "/assets/product/p4.png",
        link: "/managed-services-staff-augmentation"
    },
    {
        id: 4,
        title: "AI & Intelligent Automation",
        description: "Make your day-to-day operations easier with smart machine learning and automation, helping your team work better, save time, and grow faster.",
        image: "/assets/product/p2.png",
        link: "/ai-intelligent-automation"
    }
];

const data = [
    {
        id: 1,
        category: "DIGITAL WORKFLOWS",
        title: "Accelerating Enterprise Agility with Intelligent Workflows",
        link: "#"
    },
    {
        id: 2,
        category: "SERVICE OPERATIONS",
        title: "Unifying IT and Operations for Resilient Service Delivery",
        link: "#"
    },
    {
        id: 3,
        category: "EMPLOYEE EXPERIENCE",
        title: "Transforming the Workplace with Connected HR Services",
        link: "#"
    },
    {
        id: 4,
        category: "ASSET MANAGEMENT",
        title: "Maximizing ROI through Proactive Hardware Asset Management",
        link: "#"
    }
];

const service = [
    {
        id: 1,
        title: "ITSM Implementation",
        category: "service",
        desc: "Make your IT services smoother and more reliable with automated workflows for incident, problem, and change management.",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]",
        link: "/",
    },
    {
        id: 2,
        title: "HAM Pro (Hardware Asset Management)",
        category: "service",
        desc: "Simplify your IT asset lifecycle from purchase to disposal while reducing costs and improving efficiency.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]",
        link: "/",
    },
    {
        id: 3,
        title: "ITOM & CMDB",
        category: "service",
        desc: "Keep your services running smoothly and visible with a reliable CMDB and well-managed operations.",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]",
        link: "/",
    },
    {
        id: 4,
        title: "HRSD",
        category: "service",
        desc: "Improve employee satisfaction by making HR interactions simpler, faster, and more connected through digital solutions.",
        defaultBg: "bg-gradient-to-bl from-[#01386A] to-[#6A85B6]",
        link: "/",
    },
    {
        id: 5,
        title: "Custom Workflow Automation",
        category: "service",
        desc: "Create custom digital workflows that simplify your processes, save time, and help your business run more smoothly.",
        defaultBg: "bg-gradient-to-tr from-[#01386A] to-[#253B5C]",
        link: "/",
    },
    {
        id: 6,
        title: "Managed Support Services",
        category: "service",
        desc: "We continuously monitor, maintain, and fine-tune your ServiceNow platform to keep it running smoothly.",
        defaultBg: "bg-gradient-to-t from-[#01386A] to-[#243B55]",
        link: "/",
    },
]

function ServiceNowDigitalWorkflows() {
    return (
        <div>
            <Helmet>
    <title>
        ServiceNow Digital Workflows | ITSM & Automation Services | Mobikode
    </title>

    <meta
        name="description"
        content="Mobikode delivers ServiceNow digital workflow solutions to streamline ITSM, ITOM, HRSD, hardware asset management, and business processes through intelligent automation and connected workflows."
    />

    <meta
        name="keywords"
        content="ServiceNow Digital Workflows, ServiceNow Consulting Services, ServiceNow ITSM, ServiceNow ITSM Implementation, ServiceNow ITOM, ServiceNow CMDB Services, ServiceNow HRSD, ServiceNow Hardware Asset Management, ServiceNow HAM Pro, ServiceNow Workflow Automation, ServiceNow Custom Workflow Automation, ServiceNow Managed Support Services, ServiceNow Integration"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/capabilities/digital-workflows"
    />

    <meta
        property="og:title"
        content="ServiceNow Digital Workflows | ITSM & Automation Services | Mobikode"
    />

    <meta
        property="og:description"
        content="Transform business operations with Mobikode's ServiceNow digital workflow solutions. Connect IT, HR, and service operations with ITSM, ITOM, CMDB, HRSD, asset management, and workflow automation."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/capabilities/digital-workflows"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/what/c3.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="ServiceNow Digital Workflows | ITSM & Automation Services | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's ServiceNow solutions for ITSM, ITOM, CMDB, HRSD, hardware asset management, custom workflow automation, and managed ServiceNow support."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/what/c3.png"
    />
</Helmet>
            <ScrollToTop />
            <AiHero title="Digital Workflows" imgData="/assets/what/c3.png" />
            <section className="w-full py-[50px] lg:py-[80px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row h-auto lg:h-[323px] group">

                        <div className="overflow-hidden w-full lg:max-w-[624px] h-[250px] lg:h-full relative z-10">
                            <img
                                src="/assets/what/item16.png"
                                alt="ServiceNow Automation"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>

                        <div className="relative z-20 w-full flex flex-col justify-center lg:max-w-[656px] bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] 
                            px-[20px] py-[30px] lg:px-[40px] lg:py-[30px] 
                            -mt-6 lg:mt-0 lg:ml-0">
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-[500] font-graphik text-justify">
                                At Mobikode, we help businesses make digital transformation feel simple and natural. We bring IT, HR, and customer service together through smooth ServiceNow workflows, so teams can actually work as one instead of in silos. By replacing repetitive manual tasks with smart automation, we reduce delays, improve day-to-day efficiency, and help teams focus on what really matters, delivering better experiences and making confident, data-driven decisions.  </p>

                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>

                        </div>

                    </div>
                </div>
            </section>
            <OurServiceOffer service={service} />
            {/* <section className='overflow-hidden'>
                <div className="max-w-[1440px] lg:pb-[80px] pb-[40px] w-full mx-auto lg:px-[80px] px-[20px]">
                    <h6 className="text-center font-[600] lg:text-[31px] text-[20px] lg:pb-[80px] pb-[40px] lg:leading-[40px] leading-[30px] text-[#01386A]">Spotlight</h6>

                    <div className="flex lg:flex-row flex-col gap-5">

                        <div className="w-full lg:w-[65%] mx-auto relative group">
                            <div className="relative w-full h-[350px] lg:h-auto lg:aspect-auto">
                                <img src="/assets/what/img6.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px]">Streamlining Global IT Operations with ServiceNow ITSM</h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full lg:w-[35%] mx-auto grid gap-[20px]">

                            <div className="relative h-[300px] lg:h-auto">
                                <img src="/assets/what/img5.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px] line-clamp-2">
                                            Automating HR Onboarding for a Fortune 500 Company...
                                        </h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="relative h-[300px] lg:h-auto">
                                <img src="/assets/what/img7.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px] line-clamp-2">
                                            Reducing IT Costs by 30% with Hardware Asset Management...
                                        </h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section> */}
            <section className="w-full pb-[40px] lg:pb-[80px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[15px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row lg:items-center group lg:h-[507px]">
                        <div className="relative lg:absolute top-0 right-0 w-full lg:max-w-[656px] h-[250px] md:h-[350px] lg:h-full bg-gray-100 overflow-hidden">
                            <img
                                src="/assets/what/img8.png"
                                alt="ServiceNow Advantage"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>
                        <div className="relative z-20 w-[92%] sm:w-[85%] lg:w-full max-w-[719px] mx-auto lg:mx-0 bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] px-[20px] py-[30px] lg:px-[60px] lg:py-[80px] -mt-[40px] lg:mt-0">
                            <h3 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora mb-[15px] lg:mb-[35px] leading-[1.3]">
                                The Mobikode ServiceNow Advantage
                            </h3>
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-graphik font-[500] text-justify">
                                At Mobikode, we bring together hands-on experience and deep expertise in the ServiceNow platform to create solutions that truly make a difference. We go beyond just setting things up. We focus on making workflows smoother and ensuring your team actually uses and benefits from them. By connecting ITSM, ITOM, and HRSD, we build a more unified and seamless experience. Our aim is to help your business run more smoothly, stay flexible, and work with greater clarity and confidence every day.
                            </p>
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <Perspectives data={data} /> */}
            <RelatedServices relatedService={relatedService} />
            {/* <section className='relative'>
                <img src="/assets/product/bg1.jpg" className='lg:h-[683px] h-[800px] w-full object-cover' alt="" />
                <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px] top-1/2 -translate-y-1/2 absolute left-1/2 -translate-x-1/2">
                    <AccContact />
                </div>
            </section> */}
            <Banner title="Digital Workflows" text=" Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation." />
            <ContactSection/>
        </div>
    )
}

export default ServiceNowDigitalWorkflows